import * as Helper from './helper.js';
import * as Utility from './utility.js';
(function (window) {
    const FLT_VISITOR_ID_COOKIE_NAME = 'FLT_VISITOR_ID';
    const ENDPOINT_ANALYTICS_API_MARKETING = '/api/analytics/marketing';
    const ENDPOINT_ANALYTICS_API_ADVERTISEMENT = '/api/analytics/advertisement';
    const ANALYTICS_AD_EVENT_TYPE_IMPRESSION = 'impression';
    const ANALYTICS_AD_EVENT_TYPE_CLICK = 'click';
    const ANALYTICS_AD_EVENT_TYPE_OPTIONS = [
        ANALYTICS_AD_EVENT_TYPE_IMPRESSION,
        ANALYTICS_AD_EVENT_TYPE_CLICK,
    ];
    const ANALYTICS_MARKETING_EVENT_TYPE_IMPRESSION = 'impression';
    const ANALYTICS_MARKETING_EVENT_TYPE_CLICK = 'click';
    const ANALYTICS_MARKETING_EVENT_TYPE_OPTIONS = [
        ANALYTICS_MARKETING_EVENT_TYPE_IMPRESSION,
        ANALYTICS_MARKETING_EVENT_TYPE_CLICK,
    ];
    const ANALYTICS_MARKETING_SOURCE_TYPE_PHONE = 'phone';
    const ANALYTICS_MARKETING_SOURCE_TYPE_WEBSITE = 'website';
    const ANALYTICS_MARKETING_SOURCE_TYPE_EXTERNAL_LINK = 'external_link';
    const ANALYTICS_MARKETING_SOURCE_TYPE_EMAIL = 'email';
    const ANALYTICS_MARKETING_SOURCE_TYPE_SOCIAL_FACEBOOK = 'facebook';
    const ANALYTICS_MARKETING_SOURCE_TYPE_SOCIAL_INSTAGRAM = 'instagram';
    const ANALYTICS_MARKETING_SOURCE_TYPE_SOCIAL_OTHER_LINK = 'weblink';
    const ANALYTICS_MARKETING_SOURCE_TYPE_OPTIONS = [
        ANALYTICS_MARKETING_SOURCE_TYPE_PHONE,
        ANALYTICS_MARKETING_SOURCE_TYPE_EMAIL,
        ANALYTICS_MARKETING_SOURCE_TYPE_WEBSITE,
        ANALYTICS_MARKETING_SOURCE_TYPE_EXTERNAL_LINK,
        ANALYTICS_MARKETING_SOURCE_TYPE_SOCIAL_FACEBOOK,
        ANALYTICS_MARKETING_SOURCE_TYPE_SOCIAL_INSTAGRAM,
        ANALYTICS_MARKETING_SOURCE_TYPE_SOCIAL_OTHER_LINK,
    ];
    document.addEventListener('DOMContentLoaded', function () {
        console.log('[Analytics] [DOMContentLoaded]');
        bindDocumentEventListner();
        bindPhoneAndEmailMaskedTextEvents();
        initializeAdImpressionOnAdminUI();
        function addEvent(el, type, handler) {
            if (el.attachEvent) el.attachEvent('on' + type, handler);
            else el.addEventListener(type, handler);
        }
        function removeEvent(el, type, handler) {
            if (el.detachEvent) el.detachEvent('on' + type, handler);
            else el.removeEventListener(type, handler);
        }
        function bindDocumentEventListner() {
            document.addEventListener('listingrendered', function (event) {
                console.log('[listingrendered] [loadAdvertisementInSearchResult]');
                //console.log(event.detail);
                //TODO- Send impression data to analytcis if data has Advertisement info.
            });
            document.addEventListener('adimpression', function (event) {
                console.log('[adimpression]');
                //console.log(event.detail);
                trackAdvertisementEvent(
                    event.detail.adid,
                    event.detail.adownerid,
                    ANALYTICS_AD_EVENT_TYPE_IMPRESSION
                );
            });
            document.addEventListener('adclick', function (event) {
                console.log('[adclick]');
                //console.log(event.detail);
                trackAdvertisementEvent(
                    event.detail.adid,
                    event.detail.adownerid,
                    ANALYTICS_AD_EVENT_TYPE_CLICK
                );
            });
        }
        function bindPhoneAndEmailMaskedTextEvents() {
            let listOfElements = document.getElementsByClassName('track-analytics');
            [].forEach.call(listOfElements, function (element, i, a) {
                // attach anonymous function to click event
                addEvent(element, 'click', function (e) {
                    e.preventDefault();
                    let isUnMasked = isUnMaskedAlready(element);
                    if (isUnMasked === true) {
                        calloutForEmailAndPhone(element); // this needs to be called before unmasking the text because unmasking will change the href for phone number and email and we only want to act if it is already unmasked.
                        return;
                    }
                    unmaskedText(element);
                    let dataAttributes = element.dataset;
                    if (dataAttributes && dataAttributes.type && dataAttributes.ownerId) {
                        trackMarketingEvent(
                            ANALYTICS_MARKETING_EVENT_TYPE_CLICK,
                            dataAttributes.type,
                            dataAttributes.ownerId,
                            dataAttributes
                        );
                    }
                });
            });
        }
        function unmaskedText(element) {
            if (
                element &&
                element.dataset &&
                element.dataset.unmaskedText &&
                element.dataset.unmaskedText.length > 0
            ) {
                element.innerText = element.dataset.unmaskedText;
                if (element.dataset.type === 'phone') {
                    let phoneNumber = element.dataset.unmaskedText.replace(/\s+/g, '');
                    if (phoneNumber.indexOf('+') !== 0 && phoneNumber.length === 10) {
                        phoneNumber = '+1' + phoneNumber;
                    }
                    element.href = 'tel:' + phoneNumber;
                } else if (element.dataset.type === 'email') {
                    element.href = 'mailto:' + element.dataset.unmaskedText;
                }
            }
        }

        function isUnMaskedAlready(element) {
            return (
                element &&
                element.href &&
                element.href.length > 1 &&
                (element.href.indexOf('tel:') === 0 || element.href.indexOf('mailto:') === 0)
            );
        }

        function calloutForEmailAndPhone(element) {
            if (element.href.indexOf('tel:') === 0) {
                const callLink = document.createElement('a');
                callLink.href = element.href;
                // Append, click, and clean up
                document.body.appendChild(callLink);
                callLink.click();
                document.body.removeChild(callLink);
            } else if (element.href.indexOf('mailto:') === 0) {
                const emailLink = document.createElement('a');
                emailLink.href = element.href;
                // Append, click, and clean up
                document.body.appendChild(emailLink);
                emailLink.click();
                document.body.removeChild(emailLink);
            }
        }
        function trackMarketingEvent(eventType, sourceType, entityOwnerId, dataAttributes) {
            if (
                eventType &&
                ANALYTICS_MARKETING_EVENT_TYPE_OPTIONS.indexOf(eventType) >= 0 &&
                sourceType &&
                ANALYTICS_MARKETING_SOURCE_TYPE_OPTIONS.indexOf(sourceType) >= 0
            ) {
                //console.log('[trackMarketingEvent] tracked');
                let sourceUrl = window.location.pathname;
                let listingId =
                    dataAttributes &&
                    dataAttributes.listingid &&
                    dataAttributes.listingid.length > 0
                        ? dataAttributes.listingid
                        : '';
                let visitorId = getUniqueVisitorId();
                let marketingAnalyticCreateModel = {
                    EventType: eventType,
                    SourceType: sourceType,
                    SourceUrl: sourceUrl,
                    VisitorId: visitorId,
                    EntityOwnerId: entityOwnerId,
                };
                if (listingId && listingId != '') {
                    marketingAnalyticCreateModel['ListingId'] = parseFloat(listingId);
                }
                if (
                    listingId == '' &&
                    sourceUrl &&
                    sourceUrl.length > 0 &&
                    sourceUrl.toLowerCase().indexOf('/listings/view') >= 0
                ) {
                    marketingAnalyticCreateModel['ListingId'] = parseFloat(
                        sourceUrl.toLowerCase().replace('/listings/view/', '')
                    );
                }
                let callbackData = {
                    EventType: eventType,
                    SourceType: sourceType,
                };
                if (
                    dataAttributes &&
                    dataAttributes.link &&
                    dataAttributes.link.length > 0 &&
                    (sourceType == ANALYTICS_MARKETING_SOURCE_TYPE_WEBSITE ||
                        sourceType == ANALYTICS_MARKETING_SOURCE_TYPE_SOCIAL_FACEBOOK ||
                        sourceType == ANALYTICS_MARKETING_SOURCE_TYPE_SOCIAL_INSTAGRAM ||
                        sourceType == ANALYTICS_MARKETING_SOURCE_TYPE_SOCIAL_OTHER_LINK ||
                        sourceType == ANALYTICS_MARKETING_SOURCE_TYPE_EXTERNAL_LINK)
                ) {
                    callbackData['link'] = dataAttributes.link;
                }
                Helper.httpPost(
                    ENDPOINT_ANALYTICS_API_MARKETING,
                    null,
                    marketingAnalyticCreateModel,
                    marketingEventCallbackSuccess,
                    callbackData,
                    marketingEventCallbackError,
                    callbackData
                );
            } else {
                // console.log('[trackMarketingEvent] skip');
            }
        }

        function trackAdvertisementEvent(adId, entityOwnerId, eventType) {
            if (
                adId &&
                adId.length > 0 &&
                eventType &&
                ANALYTICS_AD_EVENT_TYPE_OPTIONS.indexOf(eventType) >= 0
            ) {
                console.log('[trackAdvertisementEvent] tracked');
                let sourceUrl = window.location.pathname;
                let visitorId = getUniqueVisitorId();
                let adAnalyticCreateModel = {
                    AdvertisementId: adId,
                    EventType: eventType,
                    SourceUrl: sourceUrl,
                    VisitorId: visitorId,
                    EntityOwnerId: entityOwnerId,
                };
                Helper.httpPost(ENDPOINT_ANALYTICS_API_ADVERTISEMENT, null, adAnalyticCreateModel);
            } else {
                console.log('[trackAdvertisementEvent] skip');
            }
        }
        function marketingEventCallbackSuccess(responseText, sourceData) {
            console.log('[marketingEventCallbackSuccess] tracked');
            if (sourceData && sourceData.link && sourceData.link.length > 0) {
                window.open(sourceData.link, '_blank');
            }
        }
        function marketingEventCallbackError(error, sourceData) {
            console.log('[marketingEventCallbackError] tracked');
        }
        function getUniqueVisitorId() {
            let uuid = Helper.getCookie(FLT_VISITOR_ID_COOKIE_NAME);
            if (uuid && uuid !== '') {
                return uuid;
            }
            uuid = String(Date.now().toString(32) + Math.random().toString(16)).replace(/\./g, '');
            Helper.setCookie(FLT_VISITOR_ID_COOKIE_NAME, uuid, 30);
            return uuid;
        }
        function initializeAdImpressionOnAdminUI() {
            let adElement = document.getElementById('saasappAdvertisementPlaceholder');
            if (adElement) {
                let isAdminAd =
                    adElement.dataset.adminAd &&
                    (adElement.dataset.adminAd == true || adElement.dataset.adminAd == 'true')
                        ? true
                        : false;
                if (!Utility.isImpressionTracked(adElement) && isAdminAd) {
                    Utility.setImpressionTracked(adElement);
                    let adid = adElement.dataset.ad;
                    let adownerid = adElement.dataset.adowner;
                    if (adid && adownerid && adid.length > 0) {
                        console.log(
                            '[initializeAdImpressionOnAdminUI] setImpressionTracked event' + adid
                        );
                        let data = { adid, adownerid };
                        const cevent = new CustomEvent('adimpression', { detail: data });
                        document.dispatchEvent(cevent);
                    }
                }
            }
        }
    });
})(window);
